<script>
  export let options = [];
  export let disabled = [];
  export let selected = 1;
  export let fitContent = false;
</script>

<div
  class="grid_container"
  class:fit_content={fitContent === true}
  style="grid-template-columns: repeat({options.length}, {fitContent ? 'max-content' : '1fr'})"
>
  {#each options as option, index}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      on:click={() => {
        if (!disabled.includes(index)) {
          selected = index;
        }
      }}
      class="grid_item"
      class:active={selected == index}
      class:disabled={disabled.includes(index)}
    >
      {option}
    </div>
  {/each}
</div>

<style>
  .grid_container {
    display: grid;
    grid-auto-flow: column;
    gap: 0.3rem;
    height: 3rem;
    background-color: var(--pax-black);
    border-radius: 0.5rem;
    align-items: center;
    padding: 0 0.3rem;
  }

  .fit_content {
    width: fit-content;
  }

  .grid_item {
    height: 2.4rem;
    width: fit-content;
    display: flex;
    border-radius: 0.5rem;
    background-color: var(--pax-black);
    color: var(--pax-white);
    justify-content: center;
    align-items: center;
    padding: 0 1rem;
    cursor: pointer;
    white-space: nowrap;
    transition:
      background-color 300ms ease-in-out,
      color 300ms ease-in-out;
    width: 100%;
  }

  .grid_item:hover:not(.disabled) {
    background-color: var(--pax-white);
    color: var(--pax-black);
  }

  .active {
    background-color: var(--pax-white);
    color: var(--pax-black);
  }

  .disabled {
    color: var(--pax-grey);
    cursor: not-allowed;
  }
</style>
